/// <amd-module name="VSSUI/Components/PersonaCard/DefaultCard" />
import * as React from "react";
import * as Resources from "VSSUI/VSS.Resources.VSSUI";

import { Label } from "OfficeFabric/Label";
import { VssPersona } from "VSSUI/VssPersona";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";
import { DefaultCardContactLineProps, DefaultCardProps } from "./ContactCard.Props";

/** @deprecated */
export class DefaultCardContactLine extends React.Component<DefaultCardContactLineProps> {
    // Render
    public render(): JSX.Element {
        return (
            <div className="default-card-contact-line-wrapper">
                <Label className="default-card-contact-line">
                    <VssIcon iconName={this.props.iconName} className="default-card-contact-line-label" />
                    {this.props.link && (
                        <a href={this.props.link} className="default-card-contact-line-link profile-card-tab-element">
                            {this.props.content}
                        </a>
                    )}
                    {!this.props.link && <span className="default-card-contact-line-no-link">{this.props.content}</span>}
                </Label>
            </div>
        );
    }
}

/** @deprecated */
export class DefaultCard extends React.Component<DefaultCardProps> {
    // Setting the focus for the case of default card mounting when we come back via back header
    public componentDidMount(): void {
        if (this.props.setFocus) {
            this.props.setFocus();
        }
    }

    // Render
    public render(): JSX.Element {
        const { identity, isPreviousHeader } = this.props;

        const mainPersonaData = {
            imageUrl: this.props.identity.image,
            primaryText: this.props.identity.displayName,
            secondaryText: this.props.identity.jobTitle,
            tertiaryText: this.props.identity.department
        };
        const mainPersona = (
            <div className="flex-row">
                <VssPersona
                    className="persona-main"
                    displayName={mainPersonaData.primaryText}
                    imageUrl={ mainPersonaData.imageUrl ? mainPersonaData.imageUrl+"?size=2" : undefined}
                    size="extra-large"
                    suppressPersonaCard={true}
                />
                <div className="flex-column flex-grow persona-card-name">
                    <div className="persona-main-text-primary title-s">{mainPersonaData.primaryText}</div>
                    {mainPersonaData.secondaryText === "" ? undefined : <div className="persona-main-text-secondary">{mainPersonaData.secondaryText}</div>}
                    {mainPersonaData.tertiaryText === "" ? undefined : <div className="persona-main-text-tertiary">{mainPersonaData.tertiaryText}</div>}
                </div>
            </div>
        );

        let managerPersona = null;
        if (this.props.manager) {
            const adjacentManager = this.props.manager;
            const adjacentManagerData = {
                imageUrl: adjacentManager.image,
                primaryText: adjacentManager.displayName,
                secondaryText: adjacentManager.jobTitle,
                tertiaryText: adjacentManager.department
            };
            managerPersona = (
                <div
                    className="persona-list-manager-element profile-card-tab-element flex-row"
                    aria-label={adjacentManager.displayName}
                    key={adjacentManager.entityId + adjacentManager.signInAddress}
                    onClick={() => {
                        this.props.onClickEntity(adjacentManager);
                    }}
                    data-is-focusable={true}
                    role="button"
                >
                    <VssPersona
                         displayName={adjacentManagerData.primaryText}
                         imageUrl={ adjacentManagerData.imageUrl}
                         size="medium-plus"
                         suppressPersonaCard={true}
                    />
                    <div className="flex-column flex-grow persona-card-name">
                        <div className="persona-list-element-text-primary">{adjacentManagerData.primaryText}</div>
                        {adjacentManagerData.secondaryText === "" ? undefined : <div className="persona-list-element-text-secondary">{adjacentManagerData.secondaryText}</div>}
                    </div>
                </div>
            );
        }

        return (
            <div className={isPreviousHeader ? "default-card-with-header" : "default-card-without-header"}>
                {/* Main persona display */}
                {mainPersona}

                {/* Section to hold brief contact information and direct manager */}
                <div>
                    {/* Brief contact information */}
                    {(identity.mail || identity.telephoneNumber || identity.physicalDeliveryOfficeName) && (
                        <div className="default-card-contact-info-wrapper">
                            <hr className="hr-main" />

                            <div className="default-card-header-wrapper">
                                <span
                                    className="default-card-header pointer profile-card-tab-element"
                                    onClick={() => {
                                        this.props.showContactCard();
                                    }}
                                    aria-label={Resources.PeoplePickerContact}
                                    data-is-focusable={true}
                                    role="button"
                                >
                                    <Label className="pointer">
                                        <b className="default-card-header-space">{Resources.PeoplePickerContact}</b>
                                        <VssIcon iconType={VssIconType.fabric} iconName="ChevronRight" />
                                    </Label>
                                </span>
                            </div>

                            <div className="default-card-contact-info-container">
                                {identity.mail && <DefaultCardContactLine iconName="Mail" content={identity.mail} link={`mailto:${identity.mail}`} />}
                                {identity.mail && (
                                    <DefaultCardContactLine iconName="Chat" content={Resources.PeoplePickerStartChat} link={`sip:${identity.mail}`} />
                                )}
                                {identity.telephoneNumber && (
                                    <DefaultCardContactLine
                                        iconName="Phone"
                                        content={identity.telephoneNumber}
                                        link={`tel:${identity.telephoneNumber}`}
                                    />
                                )}
                                {identity.physicalDeliveryOfficeName && (
                                    <DefaultCardContactLine iconName="POI" content={identity.physicalDeliveryOfficeName} />
                                )}
                            </div>
                        </div>
                    )}

                    {this._renderDirectManagerElement(managerPersona)}
                </div>
            </div>
        );
    }

    /**
     * Renders the direct manager for the persona.
     * @param managerPersona The manager persona.
     */
    private _renderDirectManagerElement(managerPersona: JSX.Element) {
        if (!managerPersona) {
            return null;
        }

        return (
            <div className="default-card-direct-manager-wrapper">
                <hr className="hr-secondary" />

                <div className="default-card-header-wrapper">
                    <span
                        className="default-card-header pointer profile-card-tab-element"
                        onClick={() => {
                            this.props.showOrganizationCard();
                        }}
                        aria-label={Resources.PeoplePickerOrganization}
                        data-is-focusable={true}
                        role="button"
                    >
                        <Label className="pointer">
                            <b className="default-card-header-space">{Resources.PeoplePickerOrganization}</b>
                            <VssIcon iconType={VssIconType.fabric} iconName="ChevronRight" />
                        </Label>
                    </span>
                </div>

                <div className="default-card-direct-manager">
                    <div className="default-card-header-reportsto">{Resources.PeoplePickerReportsTo}</div>

                    {managerPersona}
                </div>
            </div>
        );
    }
}
